exports.theme = {
  colors: {
    primary: "#8064F4",
  },
  fontFamily: {
    title: ['"Nunito"', "sans-serif"],
  },
  gridTemplateColumns: {
    mainLg: "repeat(auto-fill, minmax(max(10%, 300px), 1fr))",
    main: "repeat(auto-fill, minmax(max(30%, 150px), 1fr))",
  },
};
